import React from 'react';

import { Stack, Typography } from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';

import LineLabel from 'scenes/Trackers/HourlyTracker/components/LineLabel';

export const DateHour = ({ value, dashed }) =>
  value ? (
    <Stack spacing={1} alignItems={'center'} direction={'row'}>
      <LineLabel dashed={dashed} />
      <Typography variant={'body2'} sx={{ display: 'flex' }}>
        <DateValueFormatter value={value} timeZone={'utc'} template={'LL'} />
      </Typography>
    </Stack>
  ) : null;

export default DateHour;
